import { Result } from './result.js';

export class MersennePrimeUtils {
  /**
   * @see https://en.wikipedia.org/wiki/List_of_Mersenne_primes_and_perfect_numbers
   */
  private static readonly MERSENNE_PRIME_EXPONENTS = [
    2,
    3,
    5,
    7,
    13,
    17,
    19,
    31,
    61,
    89,
    107,
    127,
    521,
    607,
    1279,
    2203,
    2281,
    3217,
    4253,
    4423,
    9689,
    9941,
    11213,
    19937,
    21701,
    23209,
    44497,
    86243,
    110503,
    // NOTE(emil): not recommended due to bad performance.
    // 132049,
    // 216091,
    // 756839,
    // 859433,
    // 1257787,
    // 1398269,
    // 2976221,
    // 3021377,
    // 6972593,
    // 13466917,
    // 20996011,
    // 24036583,
    // 25964951,
    // 30402457,
    // 32582657,
    // 37156667,
    // 42643801,
    // 43112609,
    // 57885161,
    // 74207281,
    // 77232917,
    // 82589933,
  ];

  private static readonly cache: Map<number, bigint> = new Map();

  private static get(exponent: number): bigint {
    if(this.cache.has(exponent)) {
      return this.cache.get(exponent)!;
    }

    const result = BigInt(2) ** BigInt(exponent) - BigInt(1);
    this.cache.set(exponent, result);

    return result;
  }

  /**
   * Works for very large numbers.
   *
   * @param {bigin} target the target number.
   * @return {Result} the smallest Mersenne prime larger than the target or an error message.
   */
  public static findPrimeLargerThan(target: bigint): Result<bigint, string> {
    for(const exponent of this.MERSENNE_PRIME_EXPONENTS) {
      const candidate = this.get(exponent);
      if(candidate > target) {
        return Result.ok(candidate);
      }
    }

    return Result.error(`No Mersenne prime found larger than target {${target}}. This should not happen in any realistic scenario.`);
  }
}
